module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_37.fab5156a.png";